export default __webpack_public_path__ + "static/media/csmLogo.5b1d4481.svg";